<script setup lang="ts">
import { StaticCategoryData } from '~/lib/models/async-data'
import { McdViewError } from '~/lib/models/errors'
import { GTMContentGroup } from '~/lib/models/gtm'

definePageMeta({
  alias: ['/cardapio/:categorySlug'],
})

const route = useRoute()
const origin = useSiteDomain({ protocol: true, noOverride: true })
const { categorySlug } = getRouteParams(route.params, ['categorySlug'])
const { loadCategoryData } = useMenu()
const errorView = useErrorView()
const { trackPageView } = useGTM()

const { data, error } = await useWrapperKeyAsyncData<StaticCategoryData, McdViewError>(
  `static-category-data-${categorySlug}`,
  () => loadCategoryData(categorySlug)
)

if (error.value) {
  // I am receiving here an H3Error not a McdViewError, maybe we can try with throw createError and built in nuxt error handling
  // for now is a workaround that works
  const cause = error.value.cause instanceof McdViewError ? error.value.cause : undefined
  errorView.value = cause || error.value
}

onMounted(() => {
  if (data.value?.category) {
    trackPageView({
      cg: GTMContentGroup.primary.OUR_MENU,
      cg2: GTMContentGroup.secondary.ITEM_LIST,
      cg3: categorySlug,
    })
  }
})
</script>

<template>
  <LazyErrorView v-if="error" :error="errorView || error" />
  <section v-else-if="data && data.category">
    <!-- CategoryHorizontalMenu -->
    <CategoryHorizontalMenu :current-category-id="data.category._id" />

    <!-- StaticCategoryView -->
    <StaticCategoryView :category="data.category" :categories="data.categories" :origin="origin" />
  </section>
</template>
